import {DataTypeGroupEnum} from "../../enums/dashboard/DataTypeUnitEnum";
import {DataUnit} from "../data-unit/DataUnit";
import {AggregateFunctionTypeEnum, BucketUnitEnum} from "../../enums/dashboard/ChartsEnum";
import {UserMetricInstance} from "../user/Metric/UserMetricInstance";
import * as uuid from "uuid";

export class VirtualMetric {
  id!: number;
  name: string;
  enabled: boolean;
  isBool: boolean;
  type: VMTypeEnum;
  expression: string;
  dataTypeGroup?: DataTypeGroupEnum;
  dataUnit?: DataUnit;
  decimalDigits?: number;
  scheduledConfig?: VMScheduledConfig;
  resettableConfig?: VMResettableConfig;
  lastValue?: any;

  //FE Only
  isResettable?: boolean = false;
  dataType?: VMDataTypeEnum;


  constructor() {
    this.name = "";
    this.enabled = true;
    this.isBool = false;
    this.type = VMTypeEnum.SCHEDULED;
    this.expression = "";
    this.dataTypeGroup = DataTypeGroupEnum.INTEGER;
    this.decimalDigits = 0;
    this.scheduledConfig = new VMScheduledConfig();
    this.resettableConfig = new VMResettableConfig();
  }


}

export enum VMTypeEnum {
  RESETTABLE = "RESETTABLE", // Resettabile
  SCHEDULED = "SCHEDULED" // Schedulata
}

export enum VMResetIntervalEnum {
  M15 = "M15",
  HOUR = "HOUR",
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  BIMESTRAL = "BIMESTRAL",
  QUARTER = "QUARTER",
  YEAR = "YEAR"
}

export enum VMDataTypeEnum {
  NUMERIC = 'NUMERIC',
  BOOLEAN = 'BOOLEAN'
}

export enum MetricValueTypeForVirtualMetricEnum {
  LAST_VALUE = 'LAST_VALUE',
  AGGREGATE = 'AGGREGATE'
}

export class VMScheduledConfig {
  cronExpression: string = "0 * * * *";
  inputMetrics: VMInput[] = [];
}

export class VMResettableConfig {
  deviceId?: number;
  metricInstanceId!: number;
  alias!: string;
  resetInterval!: VMResetIntervalEnum;
  accumulate: boolean = false;
}

export class VMInput {
  metricInstanceId!: number;
  alias!: string;
  aggregateInfo!: AggregateInfo | null;

  // Frontend Only
  fullMetricInstance?: UserMetricInstance;
  aggregate: boolean;
  valueType!: MetricValueTypeForVirtualMetricEnum;
  uuid!: string;

  constructor() {
    this.valueType = MetricValueTypeForVirtualMetricEnum.LAST_VALUE;
    this.aggregate = false;
    this.aggregateInfo = null;
    this.uuid = uuid.v4()
  }

}

export class AggregateInfo {
  bucketUnits!: BucketUnitEnum;
  bucketValue!: number;
  aggregateFunction!: AggregateFunctionTypeEnum;
  samplePercentage!: number;

  constructor() {
    this.bucketUnits = BucketUnitEnum.MINUTES;
    this.bucketValue = 1;
    this.aggregateFunction = AggregateFunctionTypeEnum.MEAN;
    this.samplePercentage = 100;
  }

}
